import { tokenStorage } from './tokenStorage';

/**
 * ofetch-onRequest-Helper: hängt den aktuellen Operator-Access-Token als
 * `Authorization: Bearer …` an JEDEN BFF-Proxy-Call an.
 *
 * Sicherheit (#501): der BFF-Proxy (server.js) verifiziert diesen Bearer gegen
 * CORE, BEVOR er eine privilegierte Upstream-Credential (M2M-Secret, Service-
 * Token, Gateway-Secret) anhängt. Ohne gültigen Operator-Token → 401.
 *
 * `tokenStorage` wird vom AuthProvider gespiegelt — dieselbe Quelle wie
 * `auth.getAccessToken()` für die direkten CORE-Calls im api/client.jsx.
 */
export function attachBearer(ctx) {
  try {
    const token = tokenStorage.read()?.accessToken;
    if (token) {
      ctx.options.headers = { ...(ctx.options.headers || {}), Authorization: `Bearer ${token}` };
    }
  } catch {
    /* kein Token lesbar → Server-Gate antwortet mit 401 */
  }
}
